// eslint-disable-next-line
import React, { createElement } from 'react';
import { useSelector } from 'react-redux';
import { SceneButtons } from '../SceneButtons';
import { sceneMenuStyles } from './styles';
import { getScenesOpen } from '../../features/globals/visibilitySlice';
import { ScenePreviews } from '../ScenePreviews';
import { getOrientation } from 'GeminiViewerComponent/features/zonePreview/zonePreviewSlice';
import { OrbitPreviews } from '../OrbitPreviews';

const SceneMenu = ({
    onAssetClick,
    onOtherAssetCategoryClick,
    onCategoryClick,
    zonesByCategory,
    otherAssetsByCategory,
    searchMenu,
    controlMenu,
}) => {
    const previewOrientation = useSelector(getOrientation);

    const classes = sceneMenuStyles();

    const scenesOpen = useSelector(getScenesOpen);

    return (
        <div className={classes.sceneMenu}>
            <SceneButtons mode="asset" />
            {previewOrientation === 'vertical' ? (
                <ScenePreviews
                    open={scenesOpen}
                    onAssetClick={onAssetClick}
                    onOtherAssetCategoryClick={onOtherAssetCategoryClick}
                    onCategoryClick={onCategoryClick}
                    zonesByCategory={zonesByCategory}
                    otherAssetsByCategory={otherAssetsByCategory}
                    searchMenu={searchMenu}
                    controlMenu={controlMenu}
                />
            ) : (
                <OrbitPreviews
                    onAssetClick={onAssetClick}
                    onOtherAssetCategoryClick={onOtherAssetCategoryClick}
                    onCategoryClick={onCategoryClick}
                    zonesByCategory={zonesByCategory}
                    otherAssetsByCategory={otherAssetsByCategory}
                    searchMenu={searchMenu}
                    controlMenu={controlMenu}
                />
            )}
        </div>
    );
};

export { SceneMenu };
